import { FormikProps } from "formik";
import { useEffect } from "react";

/**
 * @description
 * Automatically scrolls the first error field into view when the form is submitted.
 * Ensure each form field uses the `name` prop correctly.
 *
 * @example
 * <Field name="<fieldName>"/>
 *
 * @param {FormikProps<T>} formik - Formik Props
 *
 * @author Rajkumar Rathod
 */
export const useFormScrollIntoView = <T>(formik: FormikProps<T>) => {
  useEffect(() => {
    /**
     * check whether form is submitted
     */
    if (!formik.isSubmitting) return;

    /**
     * check error available to evaluate scroll logic
     */
    if (Object.keys(formik.errors).length > 0) {
      const firstErrorEleName: string = Object.keys(formik.errors)[0];
      /**
       * get first error element targeted by name & scroll into view
       */
      document
        .getElementsByName(firstErrorEleName)[0]
        ?.scrollIntoView({ block: "center", behavior: "smooth" });
    }
  }, [formik]);
};
